<!-- <mat-slide-toggle *ngIf="auth.isSuperAdmin(auth.user$ | async)" (change)="showDeleteButtons($event.source.checked)">Show
  delete buttons</mat-slide-toggle> -->

<div class="container">

  <div class="row" *ngFor="let channel of channelArr$ | async; let i = index">
    <div class="col shadow bg-white" *ngFor="let data of channel; let j = index"
      (click)="onChannelClick(data.channelId,i,j)" [ngClass]="{'selected': selectedChannelId === data.channelId}">
      <i class="material-icons" id="x" *ngIf="auth.isSuperAdmin(auth.user$ | async) && showDeleteButton"
        (click)="deleteChannel($event,data.channelId,i,j)">
        clear
      </i>

      <span class="selection">
        {{data.selection +1}}
      </span>
      <span class="productType" *ngIf="data.productType">
        {{data.productType}}
      </span>
      <span class="quantity">
        {{getQuantity(data.quantity |async)}}

        <ng-container *ngIf="data.quantity | async">
          <mat-icon matTooltip="This product is not applied!" *ngIf="!isApplied(data.productId, data.quantity | async)" class="unapplied">warning</mat-icon>
        </ng-container>
      </span>
      <span class="nameOfProduct">
        {{getName(data.name)}}
      </span>
      <span class="soldOut">
        {{getStockStatus(data.quantity | async)}}
      </span>
      <img class="card-img-top" *ngIf="data.imageUrl" [src]="data.imageUrl" alt="Image">
    </div>
  </div>
</div>